import { Box, BoxProps, Button, InputAdornment, SxProps, TextField, Tooltip, Typography, styled, } from '@mui/material'
import { withStyles } from '@mui/styles'
import { OptionsObject, SnackbarKey, SnackbarMessage, VariantType } from "notistack"
import { ChangeEvent, FC, ReactElement, useEffect, useState } from "react"
import { useWeightUnit } from '../../hooks/useUnit'
import Item from '../../classes/Item'
import { kgToLbs } from './UnitComponents'
import { appConfig } from '../../config'

export const Shift = () => <Box sx={{ flexGrow: 1 }} />

export type EnqueueSnackbarType = (message: SnackbarMessage, options?: OptionsObject | undefined) => SnackbarKey

export const showMessage = (
    enqueueSnackbar: EnqueueSnackbarType,
    message: string,
    variant: VariantType = 'error',
    duration: number = 7000,
    onClose: () => void = () => { }
) => {
    enqueueSnackbar(message, {
        variant,
        anchorOrigin: {
            horizontal: 'center',
            vertical: 'bottom'
        },
        autoHideDuration: duration,
        onClose
    })
}

export const NearTooltip = withStyles({
    tooltipPlacementTop: {
        margin: "2px 0",
    },
})(Tooltip)

export const Center: FC<{ children: ReactElement | ReactElement[] }> = (props) => <Box sx={{
    boxSizing: 'border-box',
    maxWidth: '410px',
    margin: '0 auto',
    padding: '0 2rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
}}>{props.children}</Box>


const Input = styled('input')({
    display: 'none',
})

interface IUUploadButtonProps {
    buttonText: string

    onFileChange(e: ChangeEvent<HTMLInputElement>): void
}

export const UploadButton: FC<IUUploadButtonProps> = (props) => <label htmlFor="contained-button-file">
    <Input accept="image/*" id="contained-button-file" type="file" onChange={props.onFileChange} />
    <Button variant="contained" component="span">
        {props.buttonText}
    </Button>
</label>

interface IFlexProps extends BoxProps {
    children: JSX.Element | JSX.Element[]
    column?: boolean
    fullWidth?: boolean
    centerX?: boolean
    centerY?: boolean
    sx?: SxProps

}

export const Flex = ({ children, column, fullWidth, centerX, centerY, sx, ...props }: IFlexProps) => {

    return <Box sx={{
        display: 'flex',
        flexDirection: column ? 'column' : undefined,
        width: fullWidth ? 1 : undefined,
        ...(!column
            ? {
                justifyContent: centerX ? 'center' : undefined,
                alignItems: centerY ? 'center' : undefined,
            }
            : {
                justifyContent: centerY ? 'center' : undefined,
                alignItems: centerX ? 'center' : undefined,
            }),
        ...sx
    }}
        {...props}
    >
        {children}
    </Box >
}

interface IUSPhoneInputProps {

    value: string
    onChange(v: string): void

    sx?: SxProps
    small?: boolean
    withoutLabel?: boolean

}


export const USPhoneInput: FC<IUSPhoneInputProps> = (props) => {

    const acceptableSymbols = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

    const [viewValue, setViewValue] = useState('')

    useEffect(() => {
        const value = props.value
        let newViewValue = ''

        if (value.length >= 3) {
            newViewValue = `(${value.slice(0, 3)}) `

            if (value.length >= 6) {
                newViewValue += value.slice(3, 6) + ' - '

                newViewValue += value.slice(6)
            }
            else {
                newViewValue += value.slice(3)
            }

        }
        else {
            newViewValue = value
        }


        setViewValue(newViewValue)
    }, [props.value])


    const handleChange = (e: ChangeEvent<{ value: string }>) => {
        let newValue = e.target.value
        newValue = newValue.split('').filter(v => acceptableSymbols.includes(v)).join('')

        props.onChange(newValue.slice(0, 10))
    }

    return <TextField
        label={props.withoutLabel ? undefined : "Phone"}
        variant="outlined"
        value={viewValue}
        onChange={handleChange}
        sx={{ width: 1 }}
        size={props.small ? 'small' : undefined}
        InputProps={{
            startAdornment: <InputAdornment position="start">+1</InputAdornment>,
        }}
    />

}


interface ICabinetWeightTextProps {
    items: Item[]
}

export const CabinetWeightText: FC<ICabinetWeightTextProps> = props => {
    const weight = props.items.reduce((sum, current) => sum + parseFloat(current.getWeight()), 0).toFixed(appConfig.fractionDigits)
    const { unit: weightUnit } = useWeightUnit()

    return <Box style={{ position: 'absolute', left: 0, bottom: 0, margin: 17 }}>
        <Typography sx={{ fontSize: 20 }}>{weightUnit === 'kg' ? weight : kgToLbs(parseFloat(weight))} {weightUnit}</Typography>
    </Box>
}
